import type { Ref } from "vue";
import LxcError from "~/core/models/LxcError.class";
import type { Firmware } from "~/modules/firmware/models/Firmware.interface";
import firmwareService from "~/modules/firmware/services/firmware.service";

export function useCreateFirmware({
  businessUnitCode,
}: {
  businessUnitCode: number;
}) {
  const error: Ref<LxcError | null | undefined> = ref(null);
  const isLoading = ref(false);
  const result: Ref<Firmware | undefined> = ref(undefined);

  async function createFirmware(firmware: Firmware) {
    isLoading.value = true;
    error.value = undefined;

    const response = await firmwareService.createBusinessUnitFirmware(
      businessUnitCode,
      firmware,
    );

    if (LxcError.check(response)) {
      error.value = response;
    } else {
      result.value = response;
    }

    isLoading.value = false;
  }

  return {
    createFirmware,
    error,
    isLoading,
    result,
  };
}
